import { useState, useEffect } from "react";
import useWindowSize from "./useWindowSize";
import { FilterType } from "../../context/ConfigContext/types";

const useDynamicFilters = (allFilters) => {
  const [barFilters, setBarFilters] = useState([]);
  const [panelFilters, setPanelFilters] = useState([]);
  const windowSize = useWindowSize();

  useEffect(() => {
    if (!allFilters?.length) return;
    const calendarMaxWidthItem = 360;
    const numberOfBarFilters = Math.floor(Math.abs(windowSize.width - 140 - calendarMaxWidthItem) / 241);

    const langAndCatFilters = allFilters.filter(
      (f) => f.type === FilterType.CATEGORY || f.type === FilterType.LANGUAGE
    );

    const otherFilters = allFilters.filter((f) => f.type !== FilterType.CATEGORY && f.type !== FilterType.LANGUAGE);

    setBarFilters(langAndCatFilters.slice(0, numberOfBarFilters));
    setPanelFilters(langAndCatFilters.slice(numberOfBarFilters).concat(otherFilters));
  }, [windowSize, allFilters]);

  return { barFilters, panelFilters };
};

export default useDynamicFilters;
